import * as Zod from 'zod';

export const invoiceStatusScheme = Zod.object({
  id: Zod.string(),
  label: Zod.string(),
});
